export default __webpack_public_path__ + "static/media/Savant's Regalia of the Moon.4dd96443.jpg";